import React, { useState, useRef, useCallback, memo } from 'react';

const StableInput = memo(({ 
  value, 
  onChange, 
  placeholder, 
  type = "text", 
  className = "",
  required = false,
  autoComplete = "off",
  rows = null
}) => {
  const [internalValue, setInternalValue] = useState(value || '');
  const inputRef = useRef(null);
  const isControlled = value !== undefined;
  
  // Update internal value when external value changes
  React.useEffect(() => {
    if (isControlled && value !== internalValue) {
      setInternalValue(value || '');
    }
  }, [value, isControlled, internalValue]);
  
  const handleChange = useCallback((e) => {
    const newValue = e.target.value;
    setInternalValue(newValue);
    if (onChange) {
      onChange(e);
    }
  }, [onChange]);
  
  const currentValue = isControlled ? value : internalValue;
  
  const inputProps = {
    ref: inputRef,
    value: currentValue,
    onChange: handleChange,
    placeholder,
    className,
    required,
    autoComplete
  };
  
  if (type === 'textarea') {
    return (
      <textarea
        {...inputProps}
        rows={rows || 6}
        style={{
          resize: 'none',
          fontFamily: 'inherit'
        }}
      />
    );
  }
  
  return <input type={type} {...inputProps} />;
});

StableInput.displayName = 'StableInput';

export default StableInput;
